import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, text3XL, textBase, textLG } from '@styles/fonts'
import styled from 'styled-components'

export const JobFiltersTitle = styled.h1`
  ${text3XL};
  margin-bottom: 12px;
  padding-top: 32px;
  color: ${COLORS.secondary};
`

export const JobFilters = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-bottom: 40px;

  @media ${DEVICES.mobile} {
    flex-direction: column;
    align-items: start;
    justify-content: start;
  }
`

export const JobResultCount = styled.div`
  display: flex;
  align-items: center;
  ${textLG};
  color: ${COLORS.secondary};
  font-family: ${FONTS.medium};

  span:first-child {
    font-family: ${FONTS.regular};
  }

  @media ${DEVICES.mobile} {
    ${textBase};
    margin-bottom: 20px;
  }
`

export const JobFilterGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 28px;

  > div {
    margin-bottom: 0;
    min-width: 202px;
  }

  @media ${DEVICES.mobile} {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
    width: 100%;

    > div {
      min-width: 0;
      width: 50%;
    }
  }
`
